// TODO: empty file to ship in place of old build output files

// Putting this here so we don't need to download huge common.js to see version:
const key = Symbol.for('aesop-web-ui version debug');
if (!global[key]) {
  // eslint-disable-next-line no-console
  console.debug(
    ...(global[key] = [
      `aesop-web-ui: aesop-com LONG_TAG: ${process.env.LONG_TAG}`,
      JSON.stringify(process.env.aesopDependencyLogs, null, 1),
    ])
  );
}
